/**
 * Theme toggle — sun/moon icon button in the header chrome. Cycles
 * dark ↔ light with localStorage persistence (see state/theme.ts).
 *
 * Phase 5 — see docs/plans/2026-04-28-frontend-redesign.md §6.10 (Light mode).
 */

import { Moon, Sun } from 'lucide-react'
import { useThemeStore } from '../../state/theme'

export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme)
  const toggle = useThemeStore((s) => s.toggle)
  const Icon = theme === 'dark' ? Sun : Moon
  const label = theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      data-testid="theme-toggle"
      className="flex h-7 w-7 items-center justify-center border border-rule-2 text-muted hover:text-bone hover:border-rule-2 transition-colors"
    >
      <Icon size={14} strokeWidth={1.5} />
    </button>
  )
}
